import {useEffect,useRef,useState} from 'react';
import {useUi} from './config';

// Shared presentation only. Exact receipts/settlement keep authoritative values.
export function useIncreasingNumber(value:number,formatter:Intl.NumberFormat,settled=false,divisor=1){
 const duration=useUi().tokens['--motion-pool'];
 const [shown,setShown]=useState(value),displayed=useRef(value);
 useEffect(()=>{
  let frame=0;
  const preference=matchMedia('(prefers-reduced-motion: reduce)');
  const time=/^(\d+(?:\.\d+)?)\s*(ms|s)$/.exec(duration.trim());
  const milliseconds=time?Number(time[1])*(time[2]==='s'?1000:1):0;
  const from=displayed.current;
  const paint=(next:number)=>{displayed.current=next;setShown(next);};
  const finish=()=>{cancelAnimationFrame(frame);paint(value);};
  if(settled||value<=from||formatter.format(value/divisor)===formatter.format(from/divisor)||!milliseconds||preference.matches||document.hidden){finish();return;}
  const started=performance.now();
  const tick=(now:number)=>{
   const progress=Math.min(1,(now-started)/milliseconds);
   paint(progress===1?value:from+(value-from)*(1-(1-progress)**3));
   if(progress<1)frame=requestAnimationFrame(tick);
  };
  const stopIfNeeded=()=>{if(document.hidden||preference.matches)finish();};
  document.addEventListener('visibilitychange',stopIfNeeded);preference.addEventListener('change',stopIfNeeded);
  frame=requestAnimationFrame(tick);
  return()=>{cancelAnimationFrame(frame);document.removeEventListener('visibilitychange',stopIfNeeded);preference.removeEventListener('change',stopIfNeeded);};
 },[value,duration,settled,formatter,divisor]);
 return formatter.format((settled||value<shown?value:shown)/divisor);
}
